var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('MVMHeader'),_c('MVMTags',{on:{"change":_vm.changeTags}}),_c('MVMCases',{attrs:{"filter":_vm.tags}}),_c('MVMFooter'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }